import { useEffect, useState } from 'react'

export function useElementSize(element) {
  const [size, setSize] = useState({
    width: 0,
    height: 0
  })

  useEffect(() => {
    if (!element) return

    const updateSize = () => {
      setSize({
        width: element.getBoundingClientRect().width,
        height: element.getBoundingClientRect().height
      })
    }

    updateSize()

    const resizeObserver = new ResizeObserver(() => {
      updateSize()
    })

    resizeObserver.observe(element)

    return () => {
      resizeObserver.disconnect()
    }
  }, [element])

  return {
    width: size.width,
    height: size.height
  }
}
